import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

const OsadnikiCreator = () => {
  const { t } = useTranslation();

  return (
    <div>
    <Typography variant="h4" gutterBottom>{t('osadniki')}</Typography>
    </div>
  );
};

export default OsadnikiCreator;